import { IdentityProvider } from '../enums/IdentityProvider';
import { Role } from '../enums/Role';
import Resource from '../Resource';

export class User extends Resource {
  // #region class properties
  protected endpoint = '/api/v1/me';

  public name: string = '';
  public email: string = '';
  public accessToken: string = '';

  public isApiClient: boolean = false;
  public isCompanyManager: boolean = false;

  public principalId: string = '';
  public employerId: string = '';
  public employerName: string = '';

  public clientId: string = '';
  public role: Role = Role.User;
  public tempEmployerId?: string;

  public acceptedTermsAndConditions: boolean = false;
  public acceptedPrivacyPolicy: boolean = false;
  public locale?: string;

  public rolePermissions: string[] = [];

  public hasPA: boolean = false;
  public hasPE: boolean = false;

  public identityProviderType: IdentityProvider = IdentityProvider.UNKNOWN;
  // #endregion

  // #region async methods
  // TODO: Type a user report.
  public async fetchUserReportByDate(date: string): Promise<any> {
    return await this.withTempEndpoint(`/api/v1/me/report?fetchDate=${date}`, () =>
      this.list());
  }

  public async getMe(): Promise<this> {
    return (await this.list()) as unknown as this;
  }

  public async acceptPrivacyPolicy(): Promise<void> {
    await this.withTempEndpoint(`${this.endpoint}/acceptPrivacyPolicy`, () =>
      this.create({}));
  }

  public async acceptTermsAndConditions(): Promise<void> {
    await this.withTempEndpoint(`${this.endpoint}/acceptTermsAndConditions`, () =>
      this.create({}));
  }

  public async setLocale(i18nLocale: string): Promise<void> {
    const normalizedLocale = i18nLocale.includes('en') ? 'en' : 'nl';
    await this.withTempEndpoint(`${this.endpoint}/locale/${normalizedLocale}`, () =>
      this.create({}));
  }

  public async addEmployeeProfile(profileId: string): Promise<this> {
    return await this.withTempEndpoint(`${this.endpoint}/profiles/${profileId}`, () =>
      this.update({}));
  }

  public async removeEmployeeProfile(profileId: string): Promise<void> {
    await this.withTempEndpoint(`${this.endpoint}/profiles/${profileId}`, () =>
      this.delete());
  }

  public async addEmployeeTheme(themeId: string): Promise<this> {
    return await this.withTempEndpoint(`${this.endpoint}/themes/${themeId}`, () =>
      this.update({}));
  }

  public async removeEmployeeTheme(themeId: string): Promise<void> {
    await this.withTempEndpoint(`${this.endpoint}/themes/${themeId}`, () =>
      this.delete());
  }
  // #endregion

  // #region USER DASH REDO
  // public async fetchUserProfiles(): Promise<any> {
  //   this.endpoint = `${this.endpoint}/me/profiles`;
  //   return await this.list();
  // }
  // #endregion

  // #region static methods
  public static hydrate(user: User): User {
    return new User().hydrate(user);
  }

  public static hydrateMany(users: User[]): User[] {
    return users.map((user) => this.hydrate(user));
  }
  // #endregion

  // #region getters & setters
  // #endregion
}
